@if (!underConfirmation) {
<div class="options">
  <ng-content></ng-content>
  @if (removable) {
  <a class="remove" (click)="requestConfirmation()">
    <action>{{ removeLabel }}</action>
  </a>
  }
</div>
} @if (underConfirmation) {
<div class="confirm-question">Are you sure?</div>
<div class="options remove">
  <a (click)="confirm()">
    <action type="ok">yes</action>
  </a>
  <a (click)="cancel()" class="cancel"><action type="cancel">no</action></a>
</div>
}
